/**
 * 鼠标移入特效卡片
 */
export default {
  name: "PhotoCard",
  props: {
    img: {
      type: String,
      required: false
    }
  },
  created: function created() {},
  methods: {}
};